import { useAtom } from "jotai";
import { get } from "lodash";
import { alertDialogInformationState } from "../global/jotaiState";

export default function AlertDialog() {
  const [alertDialogInformation, setAlertDialogInformation] = useAtom(
    alertDialogInformationState
  );

  const { primary, secondary } = alertDialogInformation?.actions || {};

  const onClose = () => {
    setAlertDialogInformation({ open: false });
  };

  if (!get(alertDialogInformation, "open")) return;

  return (
    <div className="fixed z-[9999] overflow-y-auto top-0 w-full left-0">
      <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 opacity-75" />
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
          &#8203;
        </span>
        <div
          className="inline-block align-center p-5 bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
        >
          <div className="w-full flex flex-col space-x-2 items-center">
            <p className="text-lg font-bold">
              {" "}
              {get(alertDialogInformation, "title")}
            </p>
            <p className="text-base">
              {" "}
              {get(alertDialogInformation, "subtitle")}
            </p>
          </div>

          <div className="flex justify-end space-x-2 ml-auto">
            <button
              onClick={() => {
                secondary?.onClick?.(onClose);
              }}
              style={{ mr: 2, ...(secondary?.style || {}) }}
              className={`w-full !mt-5 text-black border border-primary-300 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${secondary?.className}`}
            >
              {get(secondary, "text")}
            </button>
            <button
              style={{ ...(primary?.style || {}) }}
              onClick={() => {
                primary?.onClick?.(onClose);
              }}
              className={`w-full !mt-5 text-white bg-primary-300 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${primary?.className}`}
            >
              {get(primary, "text")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
